<template>
  <div class="modal--createUser">
    <div class="modalCustom__header">
      <h5 class="">{{ $t(data.header) }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <CreateUserContent
      @update:last_name="last_name = $event"
      @update:first_name="first_name = $event"
      @update:email="email = $event"
    >
    </CreateUserContent>
    <CreateCredentialContent @update:username="username = $event" @update:password="updatePassword($event)">
    </CreateCredentialContent>
    <!--          End Create User Content-->

    <!-- Error Part -->
    <div v-if="catchedErrors" v-for="error in catchedErrors" v-bind:key="error">
      <p class="pt-3 text-custom_red text-sm">{{ error[0] }}</p>
    </div>
    <!-- End Errors Part -->

    <!--          Buttons Part-->
    <div class="modalCustom__footer">
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="createUser">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
    <!--          End Buttons Part-->
  </div>
</template>

<script>
import CreateUserContent from './CreateUserContent';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import CreateNewButton from '../buttons/CreateNewButton';
import CreateCredentialContent from './CreateCredentialContent';
import axiosAuth from '../../axiosMain';
export default {
  name: 'CreateUserModal',
  components: { CreateCredentialContent, CreateNewButton, SaveButton, CancelButton, CreateUserContent },
  props: {
    data: {
      type: Object,
      header: {
        type: String,
      },
    },
  },
  data: function () {
    return {
      last_name: null,
      first_name: null,
      email: null,
      username: null,
      password: null,
      catchedErrors: null,
    };
  },
  methods: {
    closeModal: function () {
      this.$emit('close');
    },
    createUser: function () {
      axiosAuth
        .post(
          '/users',
          {
            company_id: this.$route.params.id,
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            credentials: [
              {
                username: this.username,
                password: this.password.password,
                password_confirmation: this.password.confirm_password,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.closeModal();
          this.$emit('submit', response.data);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_user_was_created'),
          });
        })
        .catch((errors) => {
          this.catchedErrors = errors.response.data.errors;
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    updatePassword(password) {
      this.password = password;
    },
  },
};
</script>

<style scoped></style>
